var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoReverseTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 241.1 45.8",
    style: {
      enableBackground: "new 0 0 241.1 45.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#EF9BE5;}\n\t.st2{fill:#395EC4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27,39.2c-10.7-0.6-20.6-1.9-20.6-1.9l-0.2,0.3c0,0,13.4,2.5,22.2,3.3L27,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.5,36c-12.4-0.6-24.3-1.8-24.3-1.8L0,34.5c0,0,16,2.6,26,3.3L24.5,36z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "35,21.1 36.2,22.4 36.2,1.7 41.4,3.3 41.4,14.9 40.4,15.3 40.4,33 40.6,32.9 46,26.1 46,15.4  48.7,16.3 48.7,22.7 49.9,21.2 49.9,15.4 44.8,13.7 44.8,13.7 42.7,14.4 42.7,2.5 35,0 35,0 28,2.5 28,10.2 23.1,8.6 23.1,8.5  17.5,10.5 17.5,20.6 17.7,20.9 24.2,29.1 24.2,10.3 27.9,11.4 27.9,25.4 32.7,20.5 33.5,19.6 34.4,20.5 35,21.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.5,21.3l-5.3,5.5v7.9H39v-7.9L33.5,21.3z M33.2,29.5h-1.5V28h1.5V29.5z M33.2,27.5h-1.5V26h1.5V27.5z  M33.8,26h1.5v1.5h-1.5V26z M33.8,29.5V28h1.5v1.5H33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.7,45.8l3-3.8c-0.5,0-1.1,0-1.7,0l-1.4,1.7L15.4,20.5l-0.6-0.8H13l0.6,0.8L33.7,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.4,35.3c0.6,0,1.2-0.1,1.7-0.1l11.7-14.7l0.6-0.8h-1.7l-0.6,0.8L40.4,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.4,27.9c0.5-0.8,0.8-1.6,0.8-2.5c0.1-2.3-0.5-4.3-1.6-6c0,0-0.1-0.1-0.1-0.1c-5.7-5.7-15.6-8.4-20.1-8.4 c-0.1,0-0.2,0-0.3,0c0,0.1,0,0.2,0,0.2C50.8,12.9,67.7,17.1,66.4,27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.5,41.3c11,0,25.2-1.3,29.9-9.3c0.1-0.2,0.3-0.5,0.4-0.8c-1.9,1.8-4.5,3.3-7.8,4.4 c-6.1,2.8-15.6,3.6-24,3.7c-0.1,0-0.3,0-0.4,0c-1.3,0-2.6,0-3.9-0.1l1.6,2C34.5,41.3,36,41.3,37.5,41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.6,38c12.5,0,29.1-1.3,34.5-9.4c2.9-4.4,1.2-9.9-2-12.7c-6.4-5.7-17.5-8.3-22.6-8.3c-0.1,0-0.3,0-0.4,0 c0,0.1,0,0.2,0,0.2c6.6,1.8,24.6,5.9,23.8,17.7C67.4,33.9,50,36.1,34.4,36.1c-0.2,0-0.5,0-0.7,0c-1.6,0-3.2,0-4.7-0.1l1.5,1.9 C31.8,38,33.2,38,34.6,38z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.5,10.6l6.9,13.1l6.9-13.1h3.4l-8.9,16.9h-2.7l-8.9-16.9H77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.3,10.6h3.2v16.9h-3.2V10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.7,19.1c0-6.3,5.2-8.8,10.9-8.8c2.2,0,5.4,0.4,7.2,1.9l-1.5,2.2c-1.7-1-3.7-1.4-5.7-1.4 c-4,0-7.7,1.6-7.7,6.2s3.6,6.2,7.7,6.2c1.8,0,4.1-0.4,5.7-1.4l1.5,2.2c-1.9,1.6-4.8,1.9-7.2,1.9 C108.9,27.9,103.7,25.4,103.7,19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.8,10.6h3.2v16.9h-3.2V10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.6,10.6l10.5,13.1V10.6h3.2v16.9h-4l-10.5-13.1v13.1h-3.2V10.6H135.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153,10.6h3.2v16.9H153V10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.9,10.6h2.7l9.2,16.9h-3.4l-2.1-3.8h-10.1l-2.1,3.8h-3.4L167.9,10.6z M165.6,21.1h7.2l-3.6-6.6 L165.6,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.9,27.6v-18h10.7v2.6h-7.9v5.3h6.3V20h-6.3v7.6H182.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.2,11.7c-0.4-0.3-0.5-0.7-0.5-1.2s0.2-0.9,0.5-1.2s0.8-0.5,1.3-0.5c0.5,0,0.9,0.2,1.3,0.5 c0.3,0.3,0.5,0.7,0.5,1.2c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.8,0.5-1.3,0.5C197,12.2,196.6,12,196.2,11.7z M198.8,27.6V15.4h-2.7 v12.2H198.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.2,27.6h-2.7V8.8h2.7v8.4c0.4-0.6,0.9-1.1,1.7-1.5c0.7-0.3,1.6-0.5,2.4-0.5c1.7,0,3.1,0.6,4.3,1.7 c1.2,1.2,1.8,2.7,1.8,4.6c0,1.9-0.6,3.4-1.8,4.6c-1.2,1.2-2.6,1.8-4.3,1.8c-0.9,0-1.7-0.2-2.4-0.5s-1.3-0.9-1.7-1.5V27.6z  M205.3,21.5c0,1.1,0.4,2.1,1.1,2.8c0.7,0.7,1.6,1,2.6,1c1,0,1.9-0.4,2.6-1.1c0.7-0.7,1.1-1.6,1.1-2.7c0-1.1-0.4-2-1.1-2.7 c-0.7-0.7-1.6-1-2.6-1c-1,0-1.9,0.3-2.6,1S205.3,20.3,205.3,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230,21.5c0,0.5,0,0.8,0,1h-9.7c0.1,0.9,0.5,1.7,1.2,2.2c0.7,0.5,1.5,0.8,2.5,0.8c0.7,0,1.3-0.2,1.9-0.5 c0.6-0.3,1.1-0.7,1.4-1.3c0.3,0.1,0.7,0.3,1.2,0.5c0.5,0.2,0.9,0.4,1,0.4c-0.5,1-1.3,1.8-2.3,2.3c-1,0.5-2.1,0.8-3.3,0.8 c-1.8,0-3.3-0.6-4.5-1.8c-1.2-1.2-1.8-2.7-1.8-4.6c0-1.9,0.6-3.4,1.8-4.6c1.2-1.2,2.7-1.7,4.5-1.7c1.8,0,3.2,0.6,4.4,1.7 C229.4,18,230,19.6,230,21.5z M220.3,20.5h7.1c-0.1-0.9-0.5-1.7-1.1-2.2c-0.6-0.5-1.4-0.8-2.3-0.8c-1,0-1.8,0.3-2.4,0.8 C220.8,18.8,220.4,19.6,220.3,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.6,23.2v4.4h-2.7V15.4h2.7v2.8c0.6-2,1.7-3.1,3.3-3.1c1,0,1.7,0.2,2.2,0.5l-0.4,2.5 c-0.6-0.3-1.2-0.4-1.8-0.4c-1.1,0-1.9,0.5-2.5,1.5C235.8,20.1,235.6,21.5,235.6,23.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.1,40.9v-5.6h3.6c1,0,1.9,0.3,1.9,1.5c0,0.6-0.4,1-0.9,1.2c0.7,0.2,1.1,0.6,1.1,1.3 c0,1.2-1.1,1.6-2.1,1.6H97.1z M100.7,37.5c0.5,0,0.9-0.2,0.9-0.7c0-0.5-0.4-0.7-0.9-0.7h-2.5v1.4H100.7z M98.2,40h2.5 c0.6,0,1.1-0.1,1.1-0.8c0-0.6-0.5-0.8-1.1-0.8h-2.5V40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.2,38.3v-3.1h1.1v3.1c0,1.3,0.6,1.8,1.8,1.8s1.8-0.5,1.8-1.8v-3.1h1.1v3.1c0,1.9-1,2.7-2.9,2.7 S104.2,40.3,104.2,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.7,35.2h1.1v5.6h-1.1V35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.4,40h3.9v0.9h-5v-5.6h1.1V40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.6,36.1v-0.9h5.9v0.9h-2.4v4.8H121v-4.8H118.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.6,35.2v0.9h-4.2v1.5h4v0.9h-4v2.4h-1.1v-5.6H133.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.6,35.1c1.9,0,3.6,0.8,3.6,2.9c0,2.1-1.7,2.9-3.6,2.9s-3.6-0.8-3.6-2.9C135,36,136.7,35.1,138.6,35.1z  M136,38.1c0,1.5,1.2,2.1,2.6,2.1c1.3,0,2.6-0.5,2.6-2.1c0-1.5-1.2-2.1-2.6-2.1C137.3,36,136,36.6,136,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.7,40.9v-5.6h3.6c1.2,0,2.1,0.5,2.1,1.8c0,0.9-0.5,1.4-1.3,1.6l1.3,2.2h-1.2l-1.2-2.1h-2.2v2.1H143.7z  M144.7,37.9h2.5c0.6,0,1-0.2,1-0.9s-0.4-0.9-1-0.9h-2.5V37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.1,36.1v-0.9h5.9v0.9h-2.4v4.8h-1.1v-4.8H153.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.3,40.9v-5.6h1.1v2.3h3.6v-2.3h1.1v5.6H165v-2.4h-3.6v2.4H160.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173,35.2v0.9h-4.2v1.4h4v0.9h-4V40h4.2v0.9h-5.3v-5.6H173z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.3,35.2v0.9h-4.2v1.5h4v0.9h-4v2.4H177v-5.6H182.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.8,38.3v-3.1h1.1v3.1c0,1.3,0.6,1.8,1.8,1.8s1.8-0.5,1.8-1.8v-3.1h1.1v3.1c0,1.9-1,2.7-2.9,2.7 S183.8,40.3,183.8,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.9,36.1v-0.9h5.9v0.9h-2.4v4.8h-1.1v-4.8H190.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.2,38.3v-3.1h1.1v3.1c0,1.3,0.6,1.8,1.8,1.8s1.8-0.5,1.8-1.8v-3.1h1.1v3.1c0,1.9-1,2.7-2.9,2.7 S198.2,40.3,198.2,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.6,40.9v-5.6h3.6c1.2,0,2.1,0.5,2.1,1.8c0,0.9-0.5,1.4-1.3,1.6l1.3,2.2h-1.2l-1.2-2.1h-2.2v2.1H205.6z  M206.7,37.9h2.5c0.6,0,1-0.2,1-0.9s-0.4-0.9-1-0.9h-2.5V37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218,35.2v0.9h-4.2v1.4h4v0.9h-4V40h4.2v0.9h-5.3v-5.6H218z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoReverseTag);
export default __webpack_public_path__ + "static/media/logo-reverse-tag.11e9ad70b551a7549daa9c6b2330d0c7.svg";
export { ForwardRef as ReactComponent };